import {
  Briefcase, Brush, Cake, Dumbbell, GraduationCap, Palette, Scissors, School, ShieldCheck, ShoppingCart, Stethoscope, Store, UtensilsCrossed,
} from "lucide-react";
import { TEMPLATES } from "../data/templates";

const ICONS = { Briefcase, Brush, Cake, Dumbbell, GraduationCap, Palette, Scissors, School, ShieldCheck, ShoppingCart, Stethoscope, Store, UtensilsCrossed };

// Picking a template only fills the brief — free. Credits are used only on Generate.
export const TemplateGallery = ({ lang, onPick }) => (
  <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-950 p-3" data-testid="template-gallery">
    <div className="text-[11px] font-bold uppercase code-font text-cyan-700 dark:text-cyan-300 mb-1">
      {lang === "te" ? "టెంప్లేట్ నుండి ప్రారంభించండి" : "Start from a template"}
      <span className="ml-2 font-normal normal-case text-slate-500 dark:text-slate-400">
        {lang === "te"
          ? "ఉచితం — Generate నొక్కినప్పుడు మాత్రమే క్రెడిట్లు"
          : "free — credits only when you press Generate"}
      </span>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
      {TEMPLATES.map((tpl) => {
        const Icon = ICONS[tpl.icon] || Briefcase;
        return (
          <button
            key={tpl.id}
            type="button"
            onClick={() => onPick(tpl)}
            className="group text-left p-2.5 rounded-lg border bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 hover:border-cyan-500 hover:shadow-sm transition-all"
            data-testid={`template-card-${tpl.id}`}
          >
            <Icon className="w-4 h-4 text-cyan-700 dark:text-cyan-300 mb-1.5 group-hover:scale-110 transition-transform" />
            <div className="text-[11px] font-bold text-slate-800 dark:text-slate-100 leading-tight">
              {lang === "te" ? tpl.te : tpl.en}
            </div>
            <div className="text-[10px] text-slate-500 dark:text-slate-400 leading-snug mt-0.5">
              {lang === "te" ? tpl.descTe : tpl.descEn}
            </div>
          </button>
        );
      })}
    </div>
  </div>
);
